import { render } from "./OrderCommentConstraintSubCatalogueGrid.vue?vue&type=template&id=691e505f&ts=true"
import script from "./OrderCommentConstraintSubCatalogueGrid.vue?vue&type=script&lang=ts"
export * from "./OrderCommentConstraintSubCatalogueGrid.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__